import { SortDetails } from '~/types/searchTypes'
import type { SearchCategory, SearchDocument, SearchFacet } from '~/types/searchTypes'

import { defaultSortType } from '~/store/productContentStore'
import { fetchRetryParameters, requestHostHeaders, type RequestHostHeadersType } from '~/composables/constants/api'

export const useManufacturers = () => {
  const locale = useState<string>('locale.setting')

  const fetch = async (): Promise<string[]> => {
    const categoryPageProducts = await $fetch<SearchDocument>('/api/search/searchForCategoryItems', {
      method: 'POST',
      body: {
        locale: locale.value,
        params: null,
        categoryId: null,
        limit: 0,
        sort: SortDetails[defaultSortType],
        offset: 0,
      },
      ...fetchRetryParameters,
      headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
    })

    return (
      categoryPageProducts.facets
        .find((facet: SearchFacet): boolean => {
          return facet.key === 'manufacturer'
        })
        ?.items.map((item: SearchCategory) => {
          return item.title
        }) ?? []
    )
  }

  return {
    fetch,
  }
}
